import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "photo",
  "use": "photo-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"photo\"><path d=\"M10 6.87c-2.206 0-4 1.793-4 4 0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4z\" /><path d=\"M18 3.87h-1.93a2.001 2.001 0 01-1.664-.89l-.812-1.22A2.002 2.002 0 0011.93.87H8.07c-.668 0-1.293.334-1.664.89l-.812 1.22c-.371.556-.996.89-1.664.89H2a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2v-11a2 2 0 00-2-2zm-8 13c-3.309 0-6-2.692-6-6 0-3.309 2.691-6 6-6s6 2.691 6 6c0 3.31-2.691 6-6 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol